module.exports = __webpack_public_path__ + "static/media/check_background.ac4dcfce.png";